export default __webpack_public_path__ + "static/media/lessonsInCode.9cd2411d.jpg";